<template>
	<div>
		<div class="bg">
			<!-- solutions -->
			<div class="container">
				
				<div class="row">
						
					<div class="col-lg-4 col-md-6 mb-30">
						
							<div style="display: flex;flex-direction: column;width: 50rem;flex: 1;padding:2rem">
								<div style="position: relative;display: flex;align-items: center;font-size: 3rem;font-weight: bold;">
									<img src="../../assets/imgs/icon-dis.png" alt="" style="width: 4rem;height: 4rem;position: absolute;left: -1rem;z-index: 1;"><span style="z-index: 10;">Sustainable</span>
								</div>
								<div style="font-size: 3rem;font-weight: bold;;margin-top: 1rem;">
									Solutions
								</div>
							</div>
					</div>	
						
					<div class="col-lg-4 col-md-6 mb-30 wow fadeInUp animated">
						<div class="so-card">
							<div style="display: flex;flex-direction: column;padding: 2rem;">
								<div style=";">
									<div class="icon-bg">
										<img src="../../assets/imgs/solutions-icon-1.png" alt="" style="width: 2.5rem;height: 2.5rem;">
									</div>
								</div>
								<div style="font-size: 1.5rem;font-weight: bold;margin-top: 1rem;">
									Sanitary Care
								</div>
								<div style="font-size: 0.8rem;margin-top: 1rem;">
									Bamboo fiber diapers can provide a new experience of environmental protection, dryness and breathability.
								</div>
							</div>
						</div>
					</div>
						
					<div class="col-lg-4 col-md-6 mb-30 wow fadeInUp animated" data-wow-delay="0.2s">
						<div class="so-card">
							<div style="display: flex;flex-direction: column;padding: 2rem;">
								<div style=";">
									<div class="icon-bg">
										<img src="../../assets/imgs/solutions-icon-2.png" alt="" style="width: 2.5rem;height: 2.5rem;">
									</div>
								</div>
								<div style="font-size: 1.5rem;font-weight: bold;margin-top: 1rem;">
									Tourism Care
								</div>
								<div style="font-size: 0.8rem;margin-top: 1rem;">
									By using biodegradable disposables, users can ensure a hygienic environment during travel in a convenient and time-saving way.
								</div>
							</div>
						</div>
					</div>
						
					<div class="col-lg-4 col-md-6 mb-30 wow fadeInUp animated" data-wow-delay="0.4s">
						<div class="so-card">
							<div style="display: flex;flex-direction: column;padding: 2rem;">
								<div style=";">
									<div class="icon-bg">
										<img src="../../assets/imgs/solutions-icon-3.png" alt="" style="width: 2.5rem;height: 2.5rem;">
									</div>
								</div>
								<div style="font-size: 1.5rem;font-weight: bold;margin-top: 1rem;">
									Food Care
								</div>
								<div style="font-size: 0.8rem;margin-top: 1rem;">
									Organic food meets the needs of users in terms of nutritional balance and sustainability, giving them a better quality of life.
								</div>
							</div>
						</div>
					</div>
						
					<div class="col-lg-4 col-md-6 mb-30 wow fadeInUp animated" data-wow-delay="0.6s">
						<div class="so-card">
							<div style="display: flex;flex-direction: column;padding: 2rem;">
								<div style=";">
									<div class="icon-bg">
										<img src="../../assets/imgs/solutions-icon-4.png" alt="" style="width: 2.5rem;height: 2.5rem;">
									</div>
								</div>
								<div style="font-size: 1.5rem;font-weight: bold;margin-top: 1rem;">
									Pet Care
								</div>
								<div style="font-size: 0.8rem;margin-top: 1rem;">
									The degradable pet poop bag solves the environmental protection and hygiene problems faced by pet owners when they discard poop during pet walking.
								</div>
							</div>
						</div>
					</div>
						
					<div class="col-lg-4 col-md-6 mb-30 wow fadeInUp animated" data-wow-delay="0.8s">
						<div class="so-card">
							<div style="display: flex;flex-direction: column;padding: 2rem;">
								<div style=";">
									<div class="icon-bg">
										<img src="../../assets/imgs/solutions-icon-5.png" alt="" style="width: 2.5rem;height: 2.5rem;">
									</div>
								</div>
								<div style="font-size: 1.5rem;font-weight: bold;margin-top: 1rem;">
									Home Care
								</div>
								<div style="font-size: 0.8rem;margin-top: 1rem;">
									Non-woven non-slip slippers can meet the needs of users both in comfort and practicality, and bring them a better home experience.
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<!-- requirements -->
			<div class="container" style="margin-top: 5rem;">
				<div class="row" style="position: relative;">
					<img src="../../assets/imgs/solutions-map.png" style="position: absolute;left: 0;bottom: 0;width: 100%;">
					<div class="col-lg-6 col-md-8 mb-30 wow fadeInUp animated" style="padding: 1vw;">
							<div style="display: flex;flex-direction: column;flex: 1;padding:2rem">
								<!-- <div style="position: relative;display: flex;align-items: center;font-size: 3rem;font-weight: bold;">
									<img src="../../assets/imgs/icon-dis.png" alt="" style="width: 4rem;height: 4rem;position: absolute;left: -1rem;z-index: 1;"><span style="z-index: 10;">they are posting</span>
								</div> -->
								<div style="" class="author-title">
									<img src="../../assets/imgs/icon-dis.png" style="" class="author-title-img"><span style="z-index: 10;">GCI Insights</span>
								</div>
								<!-- <div style="" class="author-title">
									Demands
								</div> -->
								<div style="font-size: 1.5rem;font-weight: 500;margin-top: 1rem;">
									We closely keep in touch with the top entrepreneurs crossing various industries collecting the latest industry trends and insights to help businesses making sustainable innovations.
								</div>
								<div class="req-title-img-box">
									<img src="../../assets/imgs/requirements-icon.png" alt="" style="" class="req-title-img">
								</div>
							</div>
					</div>
					<div class="col-lg-6 col-md-8 mb-30 wow fadeInUp animated solution-r" data-wow-delay="0.2" style="height: 44rem;">
						<div style="position: relative;">
							<div style="background-color: #62e0c9;height: 35rem;position: absolute;left: 1rem;top:5rem;border-radius: 1.875rem;" class="box-border"></div>
							<div style="background-color: #fff;height: 35rem;position: absolute;left: 0rem;top:4rem;border: 0.1rem solid #000;border-radius: 1.875rem;" class="box-border">
								<div style="padding:3rem 2rem 1rem;height: 100%;">
									<div class="req-box">
										<vue-seamless-scroll :data="data"  :class-option="optionHover">
												<div style="display: flex;flex-direction: column;" v-for="(item, index) in data" :key="index">
													<div style="display: flex;">
														<span style="font-size: 1rem;font-weight: bold;flex: 1;">{{item.name}}</span>
														<!-- <img :src="require('../../assets/img/uneed/'+index.jpg)" alt="" style="width: 1.875rem;height: 1.875rem;border-radius: 50%;"> -->
														<div :style="{backgroundImage: 'url('+require('../../assets/imgs/uneed/'+(index+1)+'.jpg')+')'}" style="width: 1.875rem;height: 1.875rem;border-radius: 50%;
																background-position: center;background-repeat: no-repeat;background-size: cover;"></div>
													</div>
													<div style="display: flex;padding: 1rem 0;border-bottom: 1px solid #E1E1E1;margin-bottom: 1rem;">
														<img src="../../assets/imgs/requirements-box-left.png" alt="" style="width: 0.2rem">
														<div style="font-size: 0.8rem;font-weight: 400;margin-left: 1rem;display: flex;align-items: center;justify-content: center;" class="req-text">
															{{item.content}}
														</div>
													</div>
												</div>
										</vue-seamless-scroll>
									</div>
								</div>
							</div>
							<div style="position: absolute;left: 3rem;top: 3rem;width:8rem;height: 2.5rem;background-color: #FEDF34;display: flex;align-items: center;justify-content: center;
										font-size: 1rem;font-weight: bold;rotate: 355deg;">Lastest Insights</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
			// import vueSeamlessScroll from 'vue-seamless-scroll'
			export default {
				data() {
					return {
						data:[
							{content:'In trying to slow down fast fashion, regulators should focus on overproduction',name:'Kaja Dobkowska',
									avatar:require('../../assets/imgs/avatar/1.jpg')},
							{content:'The impact of nature risk on credit ratings is a wake-up call for investors',name:'Rachelle Patriarca',
									avatar:require('../../assets/imgs/avatar/2.jpg')},
							{content:'Companies ‘woefully behind’ in grappling with ethics risks of AI',name:'Yrrehc Untalan',
									avatar:require('../../assets/imgs/avatar/3.jpg')},
							{content:"Food brands struggling to weather the 'polycrisis' unleashed by war and climate change",name:'Anita Kukulska',
									avatar:require('../../assets/imgs/avatar/4.jpg')},
							{content:'Investors should tap renewed momentum for climate finance in developing nations',name:'Mari Perez Dominguez',
									avatar:require('../../assets/imgs/avatar/5.jpg')},
							{content:'We’ve been mispricing nature, now we must plug the value gap',name:'Aqilah Hayday',
									avatar:require('../../assets/imgs/avatar/6.jpg')},
							{content:'Why engagement, not fitness apps, is the key to happy employees',name:'Jennifer Johnen',
									avatar:require('../../assets/imgs/avatar/7.jpg')},
							{content:"Ending consumer confusion over recycling is 'critical' in battle against plastic waste",name:'Glaisa Dansalan',
									avatar:require('../../assets/imgs/avatar/8.jpg')},
							{content:'Green is the new black as fashion sector fast-forwards on sustainability trend',name:'Bent Bouha',
									avatar:require('../../assets/imgs/avatar/9.jpg')},
							{content:'Service is now table stakes as clients seek higher value from firms',name:'Elyah Nã',
									avatar:require('../../assets/imgs/avatar/10.jpg')},
							{content:'David Craig: ‘If business is to survive, it has to stop stealing from nature’',name:'Nicolle Muñoz',
									avatar:require('../../assets/imgs/avatar/11.jpg')},
							{content:'Why biodiversity is about to go mainstream in ESG investing',name:'Shalini Naidu',
									avatar:require('../../assets/imgs/uneed/12.jpg')},
							{content:'Indonesia economy posts slowest growth in two years as exports fall',name:'Meshell Coots',
									avatar:require('../../assets/imgs/uneed/13.jpg')},
							{content:'Can the cotton industry protect its workforce in a changing climate?',name:'Kezang Wangmo',
									avatar:require('../../assets/imgs/uneed/14.jpg')},
							{content:'Nigerian customer 15g sanitary napkin packaging film and hydrophilic non-woven fabric 180mm width',name:'Kaja Dobkowska',
									avatar:require('../../assets/imgs/uneed/15.jpg')},
							{content:'Algeria spunlace nonwoven fabric 40gsm width 102cm 20vesco/80 polys',name:'Jennifer Johnen',
									avatar:require('../../assets/imgs/uneed/16.jpg')},
						]
					}
				},
				components: {
					// vueSeamlessScroll
				},
				filters: {
		        },
				computed: {
					optionHover() {
						return {
							step: 0.3, // 数值越大速度滚动越快
							limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
							hoverStop: true, // 是否开启鼠标悬停stop
							direction: 1, // 0向下 1向上 2向左 3向右
							openWatch: true, // 开启数据实时监控刷新dom
							singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
							singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
							waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
						};
					},
				  
				},
				methods: {
					getdata(){
					}
				},
				mounted() {
					this.getdata()
				},
				beforeDestroy() {
				}
			}
</script>

<style scoped lang="scss">
	.bg{
		background: linear-gradient(359deg, #FFFFFF 0%, #F8FEFE 45%, #F0FDFD 100%);
		padding: 5rem 0 2rem;
	}
	.so-card{
		height: 18rem;
		background-color: #FFFFFF;
		border-radius: 1.875rem;
		box-shadow: 0px 14px 8px 1px rgba(0,0,0,0.06);
	}
	.so-card:hover{
		background-color: #2D3142;
		box-shadow: 0;
		color: #fff;
		transition:all .2s linear;
		
		.icon-bg{
			background: url('../../assets/imgs/solutions-light.png');
			background-repeat: no-repeat;
			background-size: contain;
		}
	}
	.icon-bg{
		background: url('../../assets/imgs/solutions-dark.png');
		width: 4rem;
		height: 4rem;
		background-repeat: no-repeat;
		background-size: contain;
		// position: absolute;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.req-box{
		// padding: 3rem 2rem 2rem;
		overflow: hidden;
		height: 100%;
	}
	.req-box::-webkit-scrollbar {display:none}
	
	.req-text{
		font-size: 0.8rem;
		font-weight: 400;
		margin-left: 1rem;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #000;
	}
	.req-text:hover{
		color: #00E8BE;
	}
	
	.author-title{
		position: relative;display: flex;align-items: center;font-size: 3.75rem;font-weight: bold;
		
		.author-title-img{
			width: 4.0625rem;height: 4.0625rem;position: absolute;left: -30px;top:1rem;z-index: 1;
		}
	}
	.box-border{
		width: 33rem;
	}
	.req-title-img-box{
		
	}
	.req-title-img{
		width: 10rem;height: 10rem;margin-top: 1rem;
	}
	@media (max-width: 767px) {
		.author-title{
			font-size: 2.5rem;
			// text-align: center;
			
			.author-title-img{
				left: -1rem;
				top: 0;
			}
		}
		.box-border{
			width: 21rem;
		}
		.req-title-img-box{
			transform: rotate(180deg);
		}
		.req-title-img{
			width: 7rem;height: 7rem;margin-top: 1rem;
		}
		.solution-r{
			margin-top: -5rem;
		}
	}
</style>